import styled from 'styled-components'

export const ImageFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ImageFieldInfo = styled.div`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--space-150);
`

export const ImageFieldName = styled.div`
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-looser);
`

export const InputPrefixAndSuffix = styled.div`
  position: absolute;
  left: 0;

  overflow: hidden;

  width: 100%;
  padding: 0 var(--space-350) 0 calc(var(--space-350) - 3px);

  color: transparent;
  pointer-events: none;

  &:after {
    content: ':';
    color: var(--text-secondary);
  }

  &:before {
    content: ':';
    color: var(--text-secondary);
  }
`
